<a [class]="buttonClass" type="button" (click)="onChangeCurrencyClick()">
  <span *ngIf="buttonText">{{ buttonText }}</span>
  <ng-content></ng-content>
</a>
